import Vue from 'vue'
import Vuex from 'vuex'
import formulaire from './modules/formulaire'
import patient from './modules/patient'
import consultation from './modules/consultation'
import consultationMotif from './modules/consultation-motif'
import consultationDmp from './modules/consultation-dmp'
import analyse from './modules/analyse'
import examen from './modules/examen'
import medicament from './modules/medicament'
import cpn from './modules/cpn'


import auth from './modules/auth'
import dossierMedical from './modules/dossier-medical'
import soin from './modules/cat/soin'
import createPersistedState from "vuex-persistedstate";

// ===> MDT
import societes from "./modules/mdtravail/societes";
import employe from "./modules/mdtravail/employe";

import parametres from "./modules/parametres/parametres";
import tarifications from "./modules/tarifications/tarifications";

import mixdata from './modules/parametres/mixdata'
import accessibilite from './modules/parametres/accessibilite'
import consultationGroupSection from './modules/consultations/consultation-group-sections'
import protocoleSoins from './modules/consultations/protocole-soins'
import historiqueConsultation from './modules/consultations/historique-consultation'

import modelesAnalyses from "./modules/parametres/modeles-analyses";
import resultatsAnalyse from './modules/resultats-analyse';
import ficheConsultation from './modules/consultations/fiche-consultations'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        patient, analyse, consultation,
        formulaire, auth, examen,
        dossierMedical, soin, medicament,
        societes, employe, cpn,
        parametres, tarifications,
        consultationMotif, consultationDmp,
        mixdata, accessibilite, consultationGroupSection,
        protocoleSoins, historiqueConsultation,
        modelesAnalyses: modelesAnalyses,
        resultatsAnalyse, ficheConsultation
    },
    plugins: [createPersistedState()]
})